import { axiosInstance } from '../../../../Interceptors/axiosInterceptor';
import ApiUrlConstant from '../../../../Shared/Utils/UrlConstants';

const Service = {
  getCountofOrder: () => {
    return axiosInstance.get(ApiUrlConstant.getCountofOrder(), { loaderKey: 'getCountofOrder' });
  },
  getPatientList: () => {
    return axiosInstance.get(`${ApiUrlConstant.getPatientList()}?pagination=no`, {
      loaderKey: 'get-patient',
    });
  },
};

export default Service;
